import {Form, InputGroup} from "react-bootstrap";

function ClientAddress(props) {
    const address = props.addresses[props.index];

    return (
        <div className={'clientAddress'}>
            <div id='address block'>
                <Form.Control id={`street`}
                              onChange={e => {address.street.set(e.target.value)}}
                              value={address.get().street}
                              placeholder={'Street'}
                />
                <Form.Control id={`street2`}
                              onChange={e => {address.street2.set(e.target.value)}}
                              value={address.get().street2}
                              placeholder={'Street 2'}
                />
                <InputGroup>
                    <Form.Control id={`city`}
                                  onChange={e => {address.city.set(e.target.value)}}
                                  value={address.get().city}
                                  placeholder={'City'}
                    />
                    <Form.Control className={"addressState"}
                                  id={`state`}
                                  onChange={e => {address.state.set(e.target.value)}}
                                  value={address.get().state}
                                  placeholder={'State'}
                    />
                    <Form.Control className={"addressZip"}
                                  id={`zip`}
                                  onChange={e => {address.zip.set(e.target.value)}}
                                  value={address.get().zip}
                                  placeholder={'Zip'}
                    />
                </InputGroup>
            </div>
        </div>
    )
}

export default ClientAddress;